import GlobalStyles from "../../assets/globalStyle";
import { SmallHeader } from "../../pages/Dashboard/styles/dashboard.style";
import colors from "../../assets/colors.json";
import CreateParentForm from "../parent_mgt/CreateParentForm";
import Loader from "../pageLoader/loader";
import PropTypes from "prop-types";
import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ErrorService from "../../services/errorService";
import { updateParentProfile } from "../../services/ParentStudent";

const Profile = ({ loading, obj, setObj }) => {
  const { admToken } = useSelector((state) => state.auth);
  const [formLoading, setFormLoading] = useState(false);

  const updateParent = async () => {
    try {
      setFormLoading(true);
        const dataToSend = {
          ...obj,
          dateOfBirth: obj.dateOfBirth
            ? (obj.dateOfBirth instanceof Date
                ? obj.dateOfBirth.toISOString()
                : new Date(obj.dateOfBirth).toISOString())
            : null,
          accountStatus: obj.accountStatus ? obj.accountStatus.toString() : "0",
        };
      const res = await updateParentProfile(admToken, dataToSend );
      setFormLoading(false);
      res.status &&
        res.statusCode === 2 &&
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      (!res.status || res.status === 400) &&
        ErrorService.displayErrorAlert(res);
    } catch (error) {
      setFormLoading(false);
      console.log(error);
      toast.error("An Error Occurred, Try Again Later");
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <GlobalStyles />
      <SmallHeader
        style={{
          fontWeight: "bold",
          color: colors.lightGray,
          marginBottom: "1.9rem",
        }}
      >
        <span style={{ marginRight: "0.9rem" }}>Parent Managment</span>
        <span style={{ marginRight: "0.9rem" }}>Parent Dashboard-</span>
        {obj && (
          <span style={{ marginRight: "0.9rem" }}>
            {`${obj.title} ${obj.fullName}`} {">>"}
          </span>
        )}
        <span style={{ color: "black" }}>Profile</span>
      </SmallHeader>
      <CreateParentForm 
        formLoading={formLoading}
        obj={obj}
        setObj={setObj} 
        action={updateParent} 
        readOnly={false} 
        isEdit={true} 
      />
    </>
  );
};

Profile.propTypes = {
  obj: PropTypes.object,
  loading: PropTypes.bool,
};

Profile.defaultProps = {
  obj: null,
  loading: true,
};
export default Profile;
